export const FIREBASE_PATH_IMAGES = "images"
